import {
  REQUEST_RECURRING,
  RECEIVE_RECURRING,
  RECEIVE_ERROR
} from "../actions/recurring";

const initialState = {
  isLoading: true,
  recurring: {},
  error: undefined
};

export default function recurringReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_RECURRING:
      return { ...state, isLoading: true, recurring: { uuid: action.uuid } };
    case RECEIVE_RECURRING:
      return { ...state, isLoading: false, recurring: action.recurring };
    case RECEIVE_ERROR:
      return { ...state, isLoading: false, error: action.message };
    default:
      return state;
  }
}
